import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
} from '@material-ui/core';
import LocalPostCodeSearchField from '../../fields/normal/LocalPostCodeSearchField';
import { COLORS } from '../../constants';

const styles = {
  root: {
    paddingBottom: '20px',
  },
  innerForm: {
    display: 'flex',
    paddingLeft: '20px',
    paddingBottom: '20px',
  },
  leftPanel: {
    width: '50%',
  },
  leftPanelInput: {
    marginBottom: '1.8rem',
    width: '80%',
  },
  rightPanel: {
    width: '50%',
  },
  rightPanelInput: {
    marginBottom: '1.8rem',
    width: '80%',
  },
  submitBtn: {
    color: COLORS.WHITE,
    backgroundColor: COLORS.GREEN,
    paddingLeft: '20px',
  },
};

const EditJobModalForm = props => {
  const {
    job,
    handleLeadJobUpdate,
    setIsOpen,
    dispatchApiCallFailed,
    dispatchApiCallSuccess,
  } = props;

  const {
    notes,
    budget,
    typeOfJob,
    plannedStartDate,
    locationOfProject,
    customerDetail,
  } = job;

  const [localNotes, setLocalNotes] = useState(notes);
  const [localBudget, setLocalBudget] = useState(budget);
  const [localJobType, setLocalJobType] = useState(typeOfJob);
  const [localStartDate, setLocalStartDate] = useState(plannedStartDate);
  const [localLocation, setLocalLocation] = useState(locationOfProject);

  const [localBudgetOptions, setLocalBudgetOptions] = useState([]);

  useEffect(() => {
    if (localJobType === 'New Builds') {
      setLocalBudgetOptions([
        '',
        'Under $100k',
        '$100k – $400k',
        '$400k – $800k',
        'More than $800k',
      ]);
    }
    if (localJobType === 'Renovations') {
      setLocalBudgetOptions([
        '',
        'Under $100k',
        '$100k – $200k',
        '$200k – $300k',
        '$300k – $400k',
        'More than $400k',
      ]);
    }
    if (localJobType === 'Other') {
      setLocalBudgetOptions([
        '',
        'Under $100k',
        '$100k – $400k',
        '$400k – $800k',
        'More than $800k',
      ]);
    }
  }, [localJobType]);

  const handleSubmit = e => {
    e.preventDefault();
    job.notes = localNotes;
    job.budget = localBudget;
    job.typeOfJob = localJobType;
    job.plannedStartDate = localStartDate;
    job.locationOfProject = localLocation;
    handleLeadJobUpdate(job);
    setIsOpen(false);
  };

  const handlePersonalInput = e => {
    const cleanValue = e.currentTarget.id.replace(/(edit-)+/g, '');
    job.customerDetail[`${cleanValue}`] = e.target.value;
  };

  return (
    <form onSubmit={handleSubmit} style={styles.root}>
      <div style={styles.innerForm}>
        <div style={styles.leftPanel}>
          <div style={styles.leftPanelContent}>
            <TextField
              label="First Name"
              id="edit-firstName"
              style={styles.leftPanelInput}
              defaultValue={customerDetail.firstName}
              onChange={handlePersonalInput}
              required
            />
            <TextField
              label="Last Name"
              id="edit-lastName"
              style={styles.leftPanelInput}
              defaultValue={customerDetail.lastName}
              onChange={handlePersonalInput}
              required
            />
            <TextField
              label="Email"
              id="edit-email"
              style={styles.leftPanelInput}
              defaultValue={customerDetail.email}
              onChange={handlePersonalInput}
              required
              type="email"
            />
            <TextField
              label="Phone"
              id="edit-phoneNumber"
              style={styles.leftPanelInput}
              defaultValue={customerDetail.phoneNumber}
              onChange={handlePersonalInput}
              required
              inputProps={{ maxLength: 10, minLength: 10 }}
            />
          </div>
        </div>
        <div style={styles.rightPanel}>
          <div style={styles.rightPanelContent}>
            <TextField
              label="Notes"
              style={styles.rightPanelInput}
              value={localNotes}
              onChange={e => setLocalNotes(e.target.value)}
              multiline
              rows={4}
            />
            <InputLabel shrink id="budget-label">
              Budget
            </InputLabel>
            <Select
              value={localBudget}
              labelId="budget-label"
              style={styles.rightPanelInput}
              onChange={e => setLocalBudget(e.target.value)}
            >
              {localBudgetOptions.map(option => (
                <MenuItem value={option}>{option}</MenuItem>
              ))}
              {/* <MenuItem value="Unsure">Unsure</MenuItem>
              <MenuItem value="Under $15000">Under $15000</MenuItem>
              <MenuItem value="$15000-$50000">$15000-$50000</MenuItem>
              <MenuItem value="More than $50000">More than $50000</MenuItem> */}
            </Select>
            <InputLabel shrink id="job-type-label">
              Type of Job
            </InputLabel>
            <Select
              value={localJobType}
              labelId="job-type-label"
              style={styles.rightPanelInput}
              onChange={e => setLocalJobType(e.target.value)}
            >
              <MenuItem value="New Builds">New Builds</MenuItem>
              <MenuItem value="Renovations">Renovations</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>
            <InputLabel shrink id="start-date-label">
              Planned Start Date
            </InputLabel>
            <Select
              value={localStartDate}
              labelId="start-date-label"
              style={styles.rightPanelInput}
              onChange={e => setLocalStartDate(e.target.value)}
            >
              <MenuItem value="0-3 Months">0-3 Months</MenuItem>
              <MenuItem value="3-6 Months">3-6 Months</MenuItem>
              <MenuItem value="6-12 Months">6-12 Months</MenuItem>
              <MenuItem value="> 12 Months">&gt; 12 Months</MenuItem>
              <MenuItem value="Unsure">Unsure</MenuItem>
            </Select>
            <LocalPostCodeSearchField
              style={styles.rightPanelInput}
              label="Job Location"
              setLocalLocation={setLocalLocation}
              initialLocation={locationOfProject}
              dispatchApiCallFailed={dispatchApiCallFailed}
              dispatchApiCallSuccess={dispatchApiCallSuccess}
            />
          </div>
        </div>
      </div>
      <Button
        variant="contained"
        style={styles.submitBtn}
        fullWidth
        type="submit"
      >
        Update Job
      </Button>
    </form>
  );
};

EditJobModalForm.propTypes = {
  job: {
    notes: PropTypes.string,
    budget: PropTypes.string,
    typeOfJob: PropTypes.string,
    plannedStartDate: PropTypes.string,
    locationOfProject: PropTypes.string,
    customerDetail: {
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      phoneNumber: PropTypes.string,
    },
  },
  handleLeadJobUpdate: PropTypes.func,
  setIsOpen: PropTypes.func,
  dispatchApiCallFailed: PropTypes.func,
  dispatchApiCallSuccess: PropTypes.func,
};

export default EditJobModalForm;
